import cx from "classnames";
import React, { CSSProperties } from "react";
import { EntityActions } from "./actions";
import { EntityMenuContext } from "./entity-menu-context";
import styles from "./entity.module.scss";
import { EntityField } from "./field";

export interface IEntity {
  children?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;

  hover?: boolean;

  menuItems?: React.ReactNode;
  checkbox?: React.ReactNode;
}

export const Entity = (props: IEntity) => {
  return (
    <div
      className={cx(styles.entity, props.hover && styles.hover, "entity", props.className)}
      style={props.style}
      id={props.htmlId}
    >
      <EntityMenuContext.Provider value={props.menuItems}>
        <div
          className={styles.content}
          style={
            {
              "--flex": 1,
            } as CSSProperties
          }
        >
          {props.checkbox && <Entity.Field width={16}>{props.checkbox}</Entity.Field>}
          {props.children}
        </div>
      </EntityMenuContext.Provider>
      {props.footer && <div className={styles.footer}>{props.footer}</div>}
    </div>
  );
};

Entity.Field = EntityField;
Entity.Actions = EntityActions;

Entity.defaultProps = {};
